import { empApi } from "./client";

// Danh sách locking -> { items, pagination }
export const getLockingListApi = (params) => empApi.get("/locking/app", params);

// Chi tiết locking
export const getLockingByIdApi = (id) => empApi.get(`/locking/app/${id}`);

// Tạo locking
export const createLockingApi = (body) => empApi.post("/locking/app", body);

// Cập nhật / Xóa locking
export const updateLockingApi = (id, body) => empApi.put(`/locking/app/${id}`, body);
export const deleteLockingApi = (id) => empApi.del(`/locking/app/${id}`);

// Danh sách thành viên chốt (CTV) của locking -> { items, pagination }
// params: { page, limit, lockingId }
export const getLockingRelativeParticipantListApi = (params) =>
  empApi.get("/lockingRelativeParticipant/app", params);

// Cập nhật hàng loạt CTV tham gia -> body { lockingId, list: [...] }
export const bulkCreateLockingRelativeParticipantApi = (body) =>
  empApi.post("/lockingRelativeParticipant/app/bulk", body);
